import { ComponentProps } from 'react';

import { FormSelectField } from '@sbv-clients/ui-forms';

type FormatFieldProps = ComponentProps<typeof FormSelectField>;

const options = [
  { id: '0', label: 'Shift', value: '0' },
  { id: '1', label: 'Unit', value: '1' },
];

export const GroupByFormField = (props: FormatFieldProps) => {
  return <FormSelectField {...props} options={options} size="small" />;
};
